export class VarianceDocRemoveCommand{
    varianceId:string;
    documentId:string;

    constructor(varianceId:string, documentId:string){
        this.varianceId = varianceId;
        this.documentId = documentId;
    }
}